import { Router } from './router';
import { PublicTrackerMethodName } from './tracker-sender.types';
import { patchHistoryAPI } from './history';
import 'nodelist-foreach-polyfill';

((reproio) => {
  // スニペット上ですでにreproioが定義されているのでnoConflictがあるかないかで実行する
  if (reproio && reproio.noConflict) {
    return;
  }
  const router = new Router();
  window.reproio = (funcName: PublicTrackerMethodName, ...args: [any, any]) => router.send(funcName, ...args);
  // プロダクションで動かす限りにおいては不要だけど、Tracker内部の状態を確認（主にテスト、デバッグ）ためにつけて置いてる
  window.reproio._rpr = router;
  const _reproio = window.reproio;
  window.reproio.noConflict = () => {
    return _reproio;
  };
  patchHistoryAPI(window, window.reproio, window.location);
})(window.reproio);
